import type { ReactNode } from 'react';
import { CloudOff, Lock, RefreshCw } from 'lucide-react';
import { Link } from 'react-router-dom';
import { butterflyPaths } from './types';
import { ButterflyBootScreen } from './ButterflyBootScreen';
import { ButterflyBrand } from './ButterflyIdentity';

export function ButterflyLoading({ text }: { text?: string }) {
  return <ButterflyBootScreen text={text} />;
}

/** Один экран состояния: бренд сверху один раз, в карточке — смысловая иконка, заголовок, пояснение и действия. */
export function ButterflyStatusScreen({ icon, eyebrow, title, children, actions }: { icon: ReactNode; eyebrow?: string; title: string; children?: ReactNode; actions?: ReactNode }) {
  return <main className="butterfly-page butterfly-page--centered butterfly-status">
    <ButterflyBrand />
    <section className="butterfly-card butterfly-status__card">
      <header>
        <span className="butterfly-card__icon">{icon}</span>
        {eyebrow ? <span className="butterfly-eyebrow">{eyebrow}</span> : null}
        <h1>{title}</h1>
      </header>
      {children}
      {actions ? <div className="butterfly-status__actions">{actions}</div> : null}
    </section>
  </main>;
}

export function ButterflyErrorView({ title = 'Не удалось открыть луг', error, ownerLink = true }: { title?: string; error: string; ownerLink?: boolean }) {
  return <ButterflyStatusScreen
    icon={ownerLink ? <CloudOff size={28} /> : <Lock size={28} />}
    eyebrow={ownerLink ? 'Луг пока недоступен' : 'Скоро снова заработает'}
    title={title}
    actions={<>
      {ownerLink ? <button className="world-button world-button--primary" type="button" onClick={() => window.location.reload()}><RefreshCw size={16} /> Попробовать снова</button> : null}
      {ownerLink ? <Link className="world-button" to={butterflyPaths.manage}>Кабинет владельца</Link> : null}
    </>}>
    <p role="alert">{error}</p>
    {ownerLink ? <p className="butterfly-status__hint">Если экран не открывается, проверьте интернет или обновите страницу через минуту.</p> : null}
  </ButterflyStatusScreen>;
}

/** Пробный мир: сколько бабочек ещё можно добавить. */
export function ButterflyTrialNotice({ remaining }: { remaining: number }) {
  return <p className="butterfly-notice" role="note">Пробная версия: можно добавить ещё {remaining} {remaining === 1 ? 'бабочку' : remaining >= 2 && remaining <= 4 ? 'бабочки' : 'бабочек'}.</p>;
}
